import TimeActivitiesComponent from 'components/TimeActivities';
import PermissionGuard from 'components/Global/PermissionGuard';

export const TimeActivities = () => {
	return (
		<PermissionGuard permission="Allow_Time_Activities">
			<TimeActivitiesComponent />
		</PermissionGuard>
	);
};
